<script lang="ts">
	import type { PistolMapping } from 'endpoint/holster_line/configurator'
	import type { HolsterAccessoryAndFriends } from 'endpoint/holster_accessory/holster_accessory'
	import type { SelectedAttributes, AllHolsterAccessoryAttributes } from 'shared/bzns/holster/accessories'
	import type { deserialize_from_address_bar } from 'shared/query_serialization'
	import { micromark } from 'micromark'

	import InputTable from 'shared/component/InputTable.svelte'
	import Label from 'shared/component/StorefrontLabel.svelte'
	import Select from 'shared/component/Select.svelte'
	import HolsterAccessoryPistolInputs from './HolsterAccessoryPistolInputs.svelte'

	export let selected_attributes: SelectedAttributes
	export let holster_accessory: HolsterAccessoryAndFriends
	export let attributes: AllHolsterAccessoryAttributes
	export let accessories: HolsterAccessoryAndFriends[]
	export let pistol_mapping: PistolMapping | undefined
	export let pistol_ref: number | null
	export let pistol_light_ref: number | null
	export let threaded = false
	export let holster_backer_ref: number | null
	export let pistol_magazine_bucket_ref: number | null
	export let holster_line: SingleJsonApiResponse<`holster_line`>
	export let initial_shopping_cart_values: ReturnType<typeof deserialize_from_address_bar>

	$: holster_accessory_attribute_refs = new Set(holster_accessory.attributes && holster_accessory.attributes.map(attribute => attribute.holster_accessory_attribute_ref))
</script>

<InputTable>
	<tbody>
		{#if pistol_mapping}
			<HolsterAccessoryPistolInputs
				{accessories}
				{pistol_mapping}
				bind:pistol_ref
				bind:pistol_light_ref
				bind:threaded
				bind:holster_backer_ref
				bind:pistol_magazine_bucket_ref
				{holster_line}
				{initial_shopping_cart_values}
			/>
		{/if}

		{#each [ ...holster_accessory_attribute_refs ] as holster_accessory_attribute_ref}
			{@const attribute = attributes[holster_accessory_attribute_ref]}
			<tr>
				<th><Label for={attribute.name}>{attribute.name}</Label></th>
				<td>
					<Select
						placeholder={attribute.name}
						bind:value={selected_attributes[holster_accessory_attribute_ref]}
						id={attribute.name}
					>
						{#each Object.values(attribute.values) as { holster_accessory_attribute_value_ref, value }}
							<option value={holster_accessory_attribute_value_ref}>{ value }</option>
						{/each}
					</Select>
				</td>
			</tr>
		{/each}

		{#if holster_accessory?.kydex_shape_configurator_comment && holster_accessory.kydex_shape_configurator_comment.trim().length}
			<tr>
				<td colspan=2>
					<div class=configurator_comment>{@html micromark(holster_accessory.kydex_shape_configurator_comment)}</div>
				</td>
			</tr>
		{/if}
	</tbody>
</InputTable>

<style>
	.configurator_comment {
		border: 1px solid #f00;
		padding: 8px;
		margin: 4px 0;
	}

	.configurator_comment :global(p) {
		margin: 8px 0;
	}
</style>
